export default __webpack_public_path__ + "static/media/Flag_of_USA.56af3c70.jpg";